import React from 'react'
import TextInput from '../../components/TextField'
import SelectInput from "../../components/SelectInput"
import { Button } from '@mui/material'
import DesktopDateTimePicker from '../../components/DesktopDateTimePicker'
import useInventory from './hook/useInventory'
import DateInput from '../../components/DateInput'
import moment from 'moment'

const InventoryForm = () => {
    const { data, methods } = useInventory()
    const { inventoryData, error } = data
    const {
        handleInputChange,
        isValid,
        AddInventory,
        UpdateInventory,
        setInventoryData,
        setError
    } = methods
    const CategoryList = [
        { name: "Hardware-Software", value: "Hardware-Software" },
        { name: "Pantry", value: "Pantry" },
        { name: "Stationary", value: "Stationary" },
        { name: "CCD", value: "CCD" },
        { name: "Specialty", value: "Specialty" },
        { name: "Decoration", value: "Decoration" },
        { name: "Product", value: "Product" },
        { name: "Others", value: "Others" },
    ];

    return (
        <div className='contact'>
            <div className='container bg'>
                <div className='col-lg-11 mt-5 mx-auto'>
                    <div className='row'>
                        <div className="text-center pt-3">
                            <h4>{inventoryData?._id ? "Update Inventory" : "Add Inventory"}</h4>
                        </div>
                        <div className="col-lg-4 mt-4">
                            <TextInput
                                Lable="Product Name"
                                Name="productName"
                                variant="outlined"
                                ClassName="form-field-design"
                                Require={true}
                                HandleInputChange={handleInputChange}
                                // onBlur={handleBlur}
                                Value={inventoryData?.productName}
                                width={100}
                                Error={error.productName}
                            />
                        </div>
                        <div className="col-lg-4 mt-4">
                            <SelectInput
                                Lable={'Category'}
                                width={'310px'}
                                Options={CategoryList}
                                className="form-field-design"
                                keyName={'name'}
                                Name="category"
                                SelectValue={inventoryData?.category}
                                HandleChange={handleInputChange}
                                // onBlur={handleBlur}
                                Error={error.category}
                                variant={'outlined'}
                                isRequired={true}
                            />
                        </div>
                        <div className="col-lg-4 mt-4">
                            <TextInput
                                Lable="Brand/Manufactuer"
                                Name="brand"
                                variant="outlined"
                                ClassName="form-field-design"
                                // Require={true}
                                HandleInputChange={handleInputChange}
                                // onBlur={handleBlur}
                                Value={inventoryData?.brand}
                                width={100}
                            // Error={error.brand}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-lg-4 mt-4">
                            <TextInput
                                Lable="Vendor"
                                Name="vendor"
                                variant="outlined"
                                ClassName="form-field-design"
                                // Require={true}
                                HandleInputChange={handleInputChange}
                                // onBlur={handleBlur}
                                Value={inventoryData?.vendor}
                                width={100}
                            // Error={error.vendor}
                            />
                        </div>

                        <div className="col-lg-4 mt-4">
                            <TextInput
                                Lable="MRP"
                                Name="mrp"
                                type={"number"}
                                variant="outlined"
                                ClassName="form-field-design"
                                Require={true}
                                HandleInputChange={handleInputChange}
                                // onBlur={handleBlur}
                                Value={inventoryData?.mrp}
                                width={100}
                                Error={error.mrp}
                            />
                        </div>
                        <div className="col-lg-4 mt-4">
                            <TextInput
                                Lable="Purchase Price"
                                Name="purchasePrice"
                                type={"number"}
                                variant="outlined"
                                ClassName="form-field-design"
                                Require={true}
                                HandleInputChange={handleInputChange}
                                // onBlur={handleBlur}
                                Value={inventoryData?.purchasePrice}
                                width={100}
                                Error={error.purchasePrice}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-lg-4 mt-4">
                            <TextInput
                                Lable="Stock Quantity"
                                Name="stockQuantity"
                                variant="outlined"
                                type={"number"}
                                ClassName="form-field-design"
                                Require={true}
                                HandleInputChange={handleInputChange}
                                // onBlur={handleBlur}
                                Value={inventoryData?.stockQuantity}
                                width={100}
                                Error={error.stockQuantity}
                            />
                        </div>

                        <div className="col-lg-4 mt-4">
                            <TextInput
                                Lable="Re-Order Level"
                                Name="reorderLevel"
                                variant="outlined"
                                ClassName="form-field-design"
                                Require={true}
                                HandleInputChange={handleInputChange}
                                // onBlur={handleBlur}
                                type={"number"}
                                Value={inventoryData?.reorderLevel}
                                width={100}
                                Error={error.reorderLevel}
                            />
                        </div>
                        <div className="col-lg-4 mt-4">
                            <DateInput
                                className="w-100 form-field-design"
                                // isRequired={true}
                                Label={'Expiry Date'}
                                handleDateChange={(date) => {
                                    setInventoryData((pre) => ({ ...pre, expireDate: date }))
                                    setError((prevErrors) => ({ ...prevErrors, expireDate: '' }))
                                }}
                                SelectedDate={inventoryData?.expireDate ? new Date(inventoryData.expireDate) : null}
                            />
                            {/* {error?.expireDate && <span className='text-danger'>{error?.expireDate}</span>} */}
                        </div>
                        <div className='d-flex justify-content-center mt-5 mb-4' >
                            <Button
                                variant="contained"
                                onClick={(e) => {
                                    if (inventoryData?._id) {
                                        // call your update function
                                        UpdateInventory(e);
                                    } else {
                                        // call your add function
                                        AddInventory(e);
                                    }
                                }}
                            >
                                {inventoryData?._id ? "Update" : "Submit"}
                            </Button>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default InventoryForm
